import React from "react";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class EditorConvertToHTML extends React.Component {
  constructor(props) {
    super(props);
    const blocksFromHtml = htmlToDraft(this.props.value);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    const editorState = EditorState.createWithContent(contentState);

    this.state = {
      editorState: editorState
    };
  }

  /** call when editor date changes */
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState
    });
    if (this.props.onChange) {
      this.props.onChange(
        draftToHtml(convertToRaw(editorState.getCurrentContent()))
      );
    }
  };

  render() {
    const { editorState } = this.state;
    return (
        <Editor
         wrapperId={"html-email-editor"}
          readOnly={this.props.disabled}
          editorState={editorState}
          wrapperClassName={
            "demo-wrapper" + (this.props.disabled ? " readonly demo-wrapper-edit" : "") +(this.props.isReply ? " demo-wrapper-reply" : "")
          }
          editorClassName={"demo-editor"}
          onEditorStateChange={this.onEditorStateChange}
        />
         
    );
  }
}
export default EditorConvertToHTML;
